import { ElementRef, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { uiGridCustomStyles } from '../configs/ui-grid-styles';

@Injectable({
  providedIn: 'root',
})
export class ShadowDomStyleInjectorService {
  injectNgPrimeStyles(el: ElementRef): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      setTimeout(() => {
        const shadowRoot = el.nativeElement.shadowRoot;
        if (!shadowRoot) {
          observer.error('shadowRoot не знайдено');
          return;
        }

        const copyStylesToShadowDom = () => {
          const globalStyles = document.querySelectorAll(
            'style[data-primeng-style-id]'
          );
          globalStyles.forEach((style: Element) => {
            const styleId = style.getAttribute('data-primeng-style-id');
            if (
              styleId &&
              !shadowRoot.querySelector(
                `style[data-primeng-style-id="${styleId}"]`
              )
            ) {
              const clonedStyle = style.cloneNode(true) as HTMLStyleElement;
              shadowRoot.appendChild(clonedStyle);
            }
          });
        };

        copyStylesToShadowDom();

        const mutationObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node as HTMLElement;
                if (
                  element.tagName.toLowerCase() === 'style' &&
                  element.hasAttribute('data-primeng-style-id')
                ) {
                  const styleId = element.getAttribute('data-primeng-style-id');
                  if (
                    styleId &&
                    !shadowRoot.querySelector(
                      `style[data-primeng-style-id="${styleId}"]`
                    )
                  ) {
                    const clonedStyle = element.cloneNode(
                      true
                    ) as HTMLStyleElement;
                    shadowRoot.appendChild(clonedStyle);
                  }
                }
              }
            });
          });
        });

        mutationObserver.observe(document.head, {
          childList: true,
          subtree: true,
        });

        observer.next(true);
        observer.complete();
      }, 0);
    });
  }

  injectUiGridStyles(el: ElementRef): void {
    const shadowRoot = el.nativeElement.shadowRoot;
    if (!shadowRoot) return;
    const uiGridStyles: string[] = [];
    const stylesheets = document.styleSheets;

    Array.from(stylesheets).forEach((stylesheet: CSSStyleSheet) => {
      try {
        const rules = stylesheet.cssRules; // This will throw for cross-origin stylesheets
        if (rules) {
          Array.from(rules).forEach((rule: CSSRule) => {
            if (
              rule instanceof CSSStyleRule &&
              rule.selectorText &&
              rule.selectorText.includes('ui-grid')
            ) {
              uiGridStyles.push(rule.cssText);
            }
          });
        }
      } catch (e) {
        // Skip stylesheets we can't access due to CORS restrictions
      }
    });

    uiGridStyles.push(uiGridCustomStyles);
    const styleElement = document.createElement('style');

    // Join all collected styles into one string and set it as the innerHTML of the style element
    styleElement.innerHTML = uiGridStyles.join('\n');

    shadowRoot.appendChild(styleElement);
  }
}
